import { AutoPriceConverterInterface } from '~/payload-types';

import TooltipWrapper from './TooltipWrapper';

//https://www.statistik.at/statistiken/volkswirtschaft-und-oeffentliche-finanzen/preise-und-preisindizes/verbraucherpreisindex-vpi/hvpi

const AutoPriceConverter = ({
  price1,
  price2 = null,
  currency,
  year,
}: {
  price1: number;
  price2?: number | null;
  currency: 'USD' | 'EUR' | 'JPY' | 'GBP' | 'CZK';
  year: number;
}) => {
  const inflationMap = [
    { year: 1990, price: 109.5 },
    { year: 1991, price: 113.1 },
    { year: 1992, price: 117.7 },
    { year: 1993, price: 121.9 },
    { year: 1994, price: 125.6 },
    { year: 1995, price: 128.4 },
    { year: 1996, price: 130.8 },
    { year: 1997, price: 132.5 },
    { year: 1998, price: 133.7 },
    { year: 1999, price: 134.5 },
    { year: 2000, price: 137.6 },
    { year: 2001, price: 141.3 },
    { year: 2002, price: 143.8 },
    { year: 2003, price: 145.8 },
    { year: 2004, price: 148.8 },
    { year: 2005, price: 152.2 },
    { year: 2006, price: 154.4 },
    { year: 2007, price: 157.8 },
    { year: 2008, price: 162.8 },
    { year: 2009, price: 163.7 },
    { year: 2010, price: 166.6 },
    { year: 2011, price: 172.0 },
    { year: 2012, price: 176.3 },
    { year: 2013, price: 179.8 },
    { year: 2014, price: 182.7 },
    { year: 2015, price: 184.4 },
    { year: 2016, price: 186.1 },
    { year: 2017, price: 189.9 },
    { year: 2018, price: 193.7 },
    { year: 2019, price: 196.7 },
    { year: 2020, price: 199.5 },
    { year: 2021, price: 205.0 },
    { year: 2022, price: 222.5 },
    { year: 2023, price: 239.9 },
    { year: 2024, price: 247.0 }, //avg 2024
    { year: 2025, price: 254.6 }, //04.2025
  ];

  const currentEuroDollarExchangeRate = 1.04;

  const vpiYear = inflationMap.find((d) => d.year == year)?.price;
  const currentYear = new Date().getFullYear();

  const vpiYearNow = inflationMap.find((d) => d.year == currentYear)?.price;

  let exchangeRate = 1;
  switch (currency) {
    case 'USD':
      exchangeRate = 0.96;
      break;
    case 'EUR':
      exchangeRate = 1;
      break;
    case 'JPY':
      exchangeRate = 0.0061;
      break;
    case 'GBP':
      exchangeRate = 1.2;
      break;
    case 'CZK':
      exchangeRate = 0.04;
      break;
  }

  let priceInEuro = null;
  let priceInDollar = null;

  if (vpiYear && vpiYearNow) {
    priceInEuro =
      Math.round(((price1 * exchangeRate) / vpiYear) * vpiYearNow * 100) / 100;
    priceInDollar =
      Math.round(priceInEuro * currentEuroDollarExchangeRate * 100) / 100;

    priceInEuro = priceInEuro.toFixed(2);
    priceInDollar = priceInDollar.toFixed(2);
  }

  let priceInEuro2 = null;
  let priceInDollar2 = null;

  if (vpiYear && vpiYearNow && price2) {
    priceInEuro2 =
      Math.round(((price2 * exchangeRate) / vpiYear) * vpiYearNow * 100) / 100;
    priceInDollar2 =
      Math.round(priceInEuro2 * currentEuroDollarExchangeRate * 100) / 100;

    priceInEuro2 = priceInEuro2.toFixed(2);
    priceInDollar2 = priceInDollar2.toFixed(2);
  }

  let content = (
    <span>
      {price1}
      {price2 ? '-' + price2 : ''}&nbsp;{currency}&nbsp;(
      {price1 * exchangeRate}
      {price2 ? '-' + price2 * exchangeRate : ''}€)
    </span>
  );

  return (
    <>
      {priceInEuro ? (
        <TooltipWrapper
          tooltip={`Price is from ${year} inflation adjusted ${priceInEuro}${priceInEuro2 ? '-' + priceInEuro2 : ''}€ or ${priceInDollar}${priceInDollar2 ? '-' + priceInDollar2 : ''}$`}
        >
          {content}
        </TooltipWrapper>
      ) : (
        content
      )}
    </>
  );
};

export default AutoPriceConverter;
